
import { defineComponent } from "vue";
import EFooter from "@/layout/eFooter.vue";
export default defineComponent({
  name: "wrapper",
  components: {
    EFooter,
  },
});
